import React from "react";
import {Button, Form, Input, Modal, notification} from "antd";
import {
	updateCustomerEmail,
	verifyCustomerEmail,
	sendCustomerEmailVerificationCode
} from "../../../services/utils";
import './modal-body.css';

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const ModalBody = ({uuId, email, setIsModalOpen, showCodeInput, setShowCodeInput, setApplication, localStorageKey, clickCount, setClickCount, showModal }) => {
	const [error, setError] = React.useState('');
	const [loading, setLoading] = React.useState(false);
	const [localEmail, setLocalEmail] = React.useState(email || '');
	const [modalCheck, setModalCheck] = React.useState(false);

	const openModalCheck = () => {
		setModalCheck(true);
		const newClickCount = clickCount + 1;
		setClickCount(newClickCount);
		localStorage.setItem(localStorageKey, newClickCount);
	};

	const closeModalCheck = () => {
		setModalCheck(false);
		setShowCodeInput(false);
		showModal()
	}

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const handleInput = (e) => {
		setLocalEmail(e.target.value);

		if (error) {
			setError('')
		}
	};

	const handleOk = async () => {
		setLoading(true);

		const res = await updateCustomerEmail(uuId, localEmail);

		if (res.ok) {
			setApplication((prev) => ({
				...prev,
				customer: {
					...prev.customer,
					email: localEmail,
				}
			}));
		} else {
			notification.error({
				message: 'Something went wrong',
			});
		}

		setLoading(false);
	};

	const sendEmailVerificationCode = async () => {
		setModalCheck(false);
		setLoading(true);

		const newClickCount = clickCount + 1;
		setClickCount(newClickCount);
		localStorage.setItem(localStorageKey, newClickCount);

		const codeRes = await sendCustomerEmailVerificationCode(uuId);

		if (codeRes.ok) {
			setShowCodeInput(true);
		} else {
			try {
				const data = await codeRes.json();

				notification.error({
					message: data.message || data.defaultMessage || data.localizedMessage,
				});
			} catch (e) {
				notification.error({
					message: 'Something went wrong',
				});
			}
		}
		setLoading(false);
	};

	return (
		<>
			{showCodeInput ? (
				<CodeForm
					uuId={uuId}
					loading={loading}
					setLoading={setLoading}
					setIsModalOpen={setIsModalOpen}
					setApplication={setApplication}
					openModalCheck={openModalCheck}
				/>
			) : (
				<Form component='div' layout='vertical'>
					<Form.Item
						help={error}
						label='Էլ. հասցե'
						labelAlign='left'
						className='mb-0 velox-form-item'
						validateStatus={error ? 'error' : ''}
					>
						<Input
							value={localEmail}
							onChange={handleInput}
						/>
					</Form.Item>
					<Form.Item
						className='mb-0'
					>
						<div className='edit-email-modal-footer'>
							<Button
								onClick={handleCancel}
							>
								Չեղարկել
							</Button>
							<Button
								onClick={sendEmailVerificationCode}
								disabled={!emailRegex.test(localEmail) || loading || (email?.trim() !== localEmail?.trim())}
							>
								Ուղարկել հաստատման կոդը
							</Button>
							<Button
								type='primary'
								onClick={handleOk}
								disabled={!emailRegex.test(localEmail) || loading || (email?.trim() === localEmail?.trim())}
							>
								Պահպանել
							</Button>
						</div>
					</Form.Item>
				</Form>
			)}
			{modalCheck &&
				<Modal
					width={600}
					footer={null}
					destroyOnClose
					maskClosable={false}
					visible={modalCheck}
					onCancel={() => setModalCheck(false)}
					className='edit-customer-email-modal'
					title={`Ստուգել էլ. հասցեն`}
				>
					<div className="modal-content">
						<p>Խնդրում ենք ևս մեկ անգամ ստուգել էլ. հասցեի <span className="modal-text-bold">{email}</span> ճշգրտությունը։</p>
						<div className="modal-button-group">
							<Button key="edit" onClick={closeModalCheck}>
								Փոփոխել
							</Button>
							<Button key="submit-ok" onClick={sendEmailVerificationCode}>
								Հաստատել
							</Button>
						</div>
					</div>

				</Modal>
			}
		</>
	)
};

const CodeForm = (
	{
		uuId,
		loading,
		setLoading,
		setApplication,
		setIsModalOpen,
		openModalCheck
	}
) => {
	const [code, setCode] = React.useState('');
	const [codeError, setCodeError] = React.useState('');

	const handleCodeInput = (e) => {
		setCode(e.target.value.replace(/\D/g, ''));

		if (codeError) {
			setCodeError('')
		}
	};

	const verifyCode = async () => {
		setLoading(true);

		const codeRes = await verifyCustomerEmail(uuId, code);

		if (codeRes.ok) {
			setApplication((prev) => ({
				...prev,
				customer: {
					...prev.customer,
					emailVerified: true,
				}
			}));

			setIsModalOpen(false);
		} else {
			try {
				const errors = await codeRes.json()
				setCodeError(errors.message || errors.defaultMessage || errors.localizedMessage);
			} catch (e) {
				setCodeError('Something went wrong');
			}
		}

		setLoading(false);
	};

	return (
		<Form component='div' layout='vertical'>
			<Form.Item
				help={codeError}
				labelAlign='left'
				label='Հաստատման կոդ'
				className='mb-0 velox-form-item'
				validateStatus={codeError ? 'error' : ''}
			>
				<Input
					value={code}
					maxLength={4}
					onChange={handleCodeInput}
				/>
			</Form.Item>
			<Form.Item
				className='mb-0'
			>
				<div className='edit-email-modal-footer'>
					<Button
						disabled={loading}
						onClick={openModalCheck}
					>
						Կրկին ուղարկել
					</Button>
					<Button
						type='primary'
						onClick={verifyCode}
						disabled={code?.trim()?.length < 4 || loading}
					>
						Հաստատել
					</Button>
				</div>
			</Form.Item>
		</Form>
	)
}